var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-w-full min-h-full fixed inset-0 flex flex-col justify-center items-center bg-white bg-opacity-75 z-20"},[_c('div',{staticClass:"spinner large h-12 w-12"}),(_vm.longLoad)?_c('div',{staticClass:"text-xs",domProps:{"textContent":_vm._s(`${_vm.$t('site.longLoad')}...`)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }